"use strict";

import _styled, { default as _styled2 } from "styled-components";
var _templateObject;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import classNames from "classnames";
import createReactClass from "create-react-class";
import PropTypes from "prop-types";
import defined from "terriajs-cesium/Source/Core/defined";
import parseCustomMarkdownToReact from "../Custom/parseCustomMarkdownToReact";
import Styles from "./notification-window.scss";
import Button from "../../Styled/Button";
import { withTheme } from "styled-components";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const NotificationWindow = createReactClass({
  displayName: "NotificationWindow",
  propTypes: {
    viewState: PropTypes.object,
    title: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.func.isRequired]),
    message: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.func.isRequired]),
    confirmText: PropTypes.string,
    denyText: PropTypes.string,
    onConfirm: PropTypes.func.isRequired,
    onDeny: PropTypes.func.isRequired,
    type: PropTypes.string,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    theme: PropTypes.object
  },
  confirm(e) {
    e.stopPropagation();
    if (this.props.onConfirm) {
      this.props.onConfirm();
    }
  },
  deny(e) {
    e.stopPropagation();
    if (this.props.onDeny) {
      this.props.onDeny();
    }
  },
  render() {
    var _this$props$title;
    const title = typeof this.props.title === "function" ? this.props.title(this.props.viewState) : (_this$props$title = this.props.title) !== null && _this$props$title !== void 0 ? _this$props$title : "";
    let message = typeof this.props.message === "function" ? this.props.message(this.props.viewState) : this.props.message;
    if (typeof message === "string") {
      message = parseCustomMarkdownToReact(message);
    }
    const confirmText = this.props.confirmText || "OK";
    const denyText = this.props.denyText;
    const type = this.props.type;
    const divStyle = {
      height: defined(this.props.height) ? this.props.height : "auto",
      width: defined(this.props.width) ? this.props.width : "500px"
    };
    const isStory = type === "story";
    return /*#__PURE__*/_jsx("div", {
      className: classNames(Styles.wrapper, "".concat(type)),
      children: /*#__PURE__*/_jsxs(_StyledDiv, {
        className: Styles.notification
        // eslint-disable-next-line react/no-unknown-property
        ,
        isStory: isStory,
        children: [/*#__PURE__*/_jsxs("div", {
          className: Styles.inner,
          style: divStyle,
          children: [/*#__PURE__*/_jsx("h3", {
            className: "title",
            children: title
          }), window.location.host === "localhost:3001" && title.toLowerCase().indexOf("error") >= 0 && /*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx("img", {
              src: "./build/TerriaJS/images/feature.gif"
            })
          }), /*#__PURE__*/_jsx("div", {
            className: Styles.body,
            children: message
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: Styles.footer,
          children: [denyText && /*#__PURE__*/_jsx(_StyledButton, {
            onClick: this.deny,
            textProps: {
              medium: true
            },
            $_css: this.props.theme.darkLighter,
            children: denyText
          }), /*#__PURE__*/_jsx(Button, {
            primary: true,
            transparent: true,
            onClick: this.confirm,
            textProps: {
              medium: true
            },
            children: confirmText
          })]
        })]
      })
    });
  }
});
export default withTheme(NotificationWindow);
var _StyledDiv = _styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n            background: ", ";\n            a,\n            a:visited {\n              color: ", ";\n            }\n          "])), p => p.theme.dark, p => p.theme.primary);
var _StyledButton = _styled2(Button).withConfig({
  displayName: "NotificationWindow___StyledButton",
  componentId: "sc-m06je-0"
})(p => ({
  backgroundColor: p.$_css,
  border: "none",
  color: "white"
}));